/**
 * CP-365: texto contra el que el buscador de Bind (Movimientos / Transferencias)
 * matchea el importe.
 *
 * `String(55054.70)` es `"55054.7"` (JS pierde el cero final), así que buscar
 * `"55054.70"` no encontraba el movimiento. Se usa siempre 2 decimales fijos,
 * con punto y con coma, para que matchee el importe completo tipeado en
 * cualquiera de los dos formatos. El formato de pantalla (`$ 55.054,70`) lo
 * agrega cada página con su `fmtMoney`.
 */
export function importeSearchText(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "";
  const fixed = n.toFixed(2);
  return `${fixed} ${fixed.replace(".", ",")}`;
}
